export const WEBSITE_NAME: string = `GoAI`;
